import script from "./AttachmentPreview.vue?vue&type=script&setup=true&lang=ts"
export * from "./AttachmentPreview.vue?vue&type=script&setup=true&lang=ts"

import "./AttachmentPreview.vue?vue&type=style&index=0&id=5f8f0cd9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f8f0cd9"]])

export default __exports__